'use strict';

document.getElementById('btn__form').onclick = function(e) {
  document.getElementById('input__form').value = '';
};
